import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { IFlightSearchRequest } from 'src/app/models/request/IRequest';
import { IFlightDeepLinkResponse } from 'src/app/models/response/flight-deeplink.response';
import { IFlightJourneys, IFlightSearchResponse } from 'src/app/models/response/flight.response';
import { CryptoService } from 'src/app/services/crypto.service';
import { EventService } from 'src/app/services/event.service';
import { FlightService } from 'src/app/services/flight.service';
import { environment } from 'src/environments/environment';
import { AuthService, HttpService, LoaderService, UtilityService } from '../../../services';

@Component({
  selector: 'app-domestic-flight-round-itinerary',
  templateUrl: './domestic-flight-round-itinerary.component.html',
  styleUrls: ['./domestic-flight-round-itinerary.component.scss']
})
export class DomesticFlightRoundItineraryComponent implements OnInit {

  @Input() domesticFlightJourneys: IFlightSearchResponse[] = [];
  @Input() flightRequest: IFlightSearchRequest;

  ticonv:boolean=true;
  tflexv:boolean=false;
  teasyv:boolean=false;
  morefare: any = [];
  moretext: any = 'More Fares';
  moreReturntext = 'More Fares';
  isOriginPriceAsc: boolean = true;
  isDestinationPriceAsc: boolean = true;
  isOriginDuration: boolean = true;
  isDestinationDuration: boolean = true;
  isOriginArrive: boolean = true;
  isDesitnationArrive: boolean = true;
  isOriginDepart: boolean = true
  isDestinationDepart: boolean = true
  isLoaded: boolean = false;
  selectedPriceType: string;
  visible:boolean=false;
  visi:boolean=false;

  constructor(
    private flight: FlightService, private ActivatedRoute: ActivatedRoute, public loaderService: LoaderService, private cryptoService: CryptoService,
    private snackbar: MatSnackBar, private router: Router, private eventService: EventService, public utilities: UtilityService, private authService: AuthService,
  ) { }

  @Input() isSelectable = false;
  @Input() editable = true;
  selectedItem: any = "";
  selectedItemRound: any = "";
  singleTrip: any = "";
  roundTrip: any = "";
  // selectedFistTrip;
  // selectedRoundItem;
  selectedFistTrip: any[] = [];
  selectedRoundItem: any[] = [];
  singleTripTotal;
  roundTripTotal;
  showFlightDetails = false;
  morefareReturn: any = [];
  ngOnInit(): void {
    this.eventService.subscribe('flight-result', (res) => {
      console.log(res, 'dsfdsf');

      if (res) {
        this.isLoaded = res;
      }
    })
    this.domesticFlightJourneys = this.domesticFlightJourneys.map((domesticflightjourneys: IFlightSearchResponse) => {
      domesticflightjourneys.flightjourneys?.map((flight: IFlightJourneys) => {
        flight.show = false
        return flight;
      })
      return domesticflightjourneys;
    })
    this.ActivatedRoute.params.subscribe((params: any) => {
      console.log(params);
      if(params) {
        localStorage.setItem('flightSearchParams', JSON.stringify(params));
        this.flightRequest = {
          credentials: this.utilities.getApiRequestCredentials(),
          destination: params.travelDetail.split('-')[1],
          numadults: this.getPassengerCounts(params.passengerDetail)[0],
          numchildren: this.getPassengerCounts(params.passengerDetail)[1],
          numinfants: this.getPassengerCounts(params.passengerDetail)[2],
          numresults: '210',
          onwarddate: params.deptDate,
          origin: params.travelDetail.split('-')[0],
          prefcarrier: 'All',
          prefclass: params.bookingClass,
          returndate: params.bookingClass == 'One Way' ? "" : params.returnDate
        }
      }
    })
    // this.ActivatedRoute.queryParams.subscribe((queryParam: any) => {
    //   if (queryParam) {
    //     this.flightRequest = JSON.parse(queryParam.itinerary);
    //   }
    // })
    var window_width = window.innerWidth;
    if (window_width < 768) {
      this.visible = true;
      this.visi = true;
  }


  }

  getPassengerCounts(passengerDetail: string) {
    return passengerDetail ? passengerDetail.split(',') : null;
  }

  ngOnChanges(): void {
    console.log(this.domesticFlightJourneys, 'step 3');
    if(this.domesticFlightJourneys?.length === 2) {
      setTimeout(() => this.isLoaded = true, 0)
    }

    if(this.domesticFlightJourneys?.length > 0) {
      this.select(this.domesticFlightJourneys[0]?.flightjourneys[0]);
      this.selectRound(this.domesticFlightJourneys[1]?.flightjourneys[0]);
      // this.domesticFlightJourneys.forEach((domesticflightjourneys: IFlightSearchResponse) => {
      //   if(domesticflightjourneys.flightjourneys?.length > 0) {
      //     this.select(domesticflightjourneys.flightjourneys[0]);
      //     this.selectRound(domesticflightjourneys.flightjourneys[1]);
      //   }
      // })
    }

  }

  shoeMorefareReturn(i: any) {
    this.morefareReturn[i] = !this.morefareReturn[i];
  }

  shoeMorefare(i: any) {
    this.morefare[i] = !this.morefare[i];

  }
  select(newValue) {
    this.selectedItem = newValue;
    localStorage.setItem('flight_Item', JSON.stringify(this.selectedItem));
    this.singleTrip = JSON.parse(localStorage.getItem('flight_Item')!);
    this.singleTripTotal = this.singleTrip.flightfare.totalnet;
  }


  selectRound(newValue) {
    this.selectedItemRound = newValue;
    localStorage.setItem('flight_Round', JSON.stringify(this.selectedItemRound));
    this.roundTrip = JSON.parse(localStorage.getItem('flight_Round')!);
    this.roundTripTotal = this.selectedItemRound.flightfare?.totalnet;
  }

  // selectFistTrip(item) {
  //   this.selectedFistTrip = (item)
  // }

  // selectRoundTrip(item) {
  //   this.selectedRoundItem = (item)
  // }

  selectFistTrip(index) {
    this.selectedFistTrip[index] = !this.selectedFistTrip[index]
  }

  selectRoundTrip(index) {
    this.selectedRoundItem[index] = !this.selectedRoundItem[index]
  }

  sortByOriginDepart() {
    this.isOriginDepart = !this.isOriginDepart
    this.domesticFlightJourneys.forEach((domesticflightjourneys: IFlightSearchResponse) => {
      domesticflightjourneys.flightjourneys.sort(
        (a: IFlightJourneys, b: IFlightJourneys) =>
          this.isOriginDepart ?
            a.flightlegs[0][0].deptime.localeCompare(b.flightlegs[0][0].deptime) :
            b.flightlegs[0][0].deptime.localeCompare(a.flightlegs[0][0].deptime)
      )
    })
  }

  sortByDestinationDepart() {
    this.isDestinationDepart = !this.isDestinationDepart
    this.domesticFlightJourneys.forEach((domesticflightjourneys: IFlightSearchResponse) => {
      domesticflightjourneys.flightjourneys.sort(
        (a: IFlightJourneys, b: IFlightJourneys) =>
          this.isDestinationDepart ?
            a.flightlegs[1][0].deptime.localeCompare(b.flightlegs[1][0].deptime) :
            b.flightlegs[1][0].deptime.localeCompare(a.flightlegs[1][0].deptime)
      )
    })
  }

  sortByOriginArrive() {
    this.isOriginArrive = !this.isOriginArrive
    this.domesticFlightJourneys.forEach((domesticflightjourneys: IFlightSearchResponse) => {
      domesticflightjourneys.flightjourneys.sort(
        (a: IFlightJourneys, b: IFlightJourneys) =>
          this.isOriginArrive ?
            a.flightlegs[0][a.flightlegs[0].length-1].arrtime.localeCompare(b.flightlegs[0][b.flightlegs[0].length-1].arrtime) :
            b.flightlegs[0][b.flightlegs[0].length-1].arrtime.localeCompare(a.flightlegs[0][a.flightlegs[0].length-1].arrtime)
      )
    })
  }

  sortByDesitnationArrive() {
    this.isDesitnationArrive = !this.isDesitnationArrive
    this.domesticFlightJourneys.forEach((domesticflightjourneys: IFlightSearchResponse) => {
      domesticflightjourneys.flightjourneys.sort(
        (a: IFlightJourneys, b: IFlightJourneys) =>
          this.isDesitnationArrive ?
            a.flightlegs[1][a.flightlegs[1].length-1].arrtime.localeCompare(b.flightlegs[1][b.flightlegs[1].length-1].arrtime) :
            b.flightlegs[1][b.flightlegs[1].length-1].arrtime.localeCompare(a.flightlegs[1][a.flightlegs[1].length-1].arrtime)
      )
    })
  }

  sortByOriginDuration() {
    this.isOriginDuration = !this.isOriginDuration
    this.domesticFlightJourneys.forEach((domesticflightjourneys: IFlightSearchResponse) => {
      domesticflightjourneys.flightjourneys.sort(
        (a: IFlightJourneys, b: IFlightJourneys) =>
          this.isOriginDuration ? a.totaljourneyduration - b.totaljourneyduration : b.totaljourneyduration - a.totaljourneyduration
      )
    })
  }

  sortByDestinationDuration() {
    this.isDestinationDuration = !this.isDestinationDuration
    this.domesticFlightJourneys.forEach((domesticflightjourneys: IFlightSearchResponse) => {
      domesticflightjourneys.flightjourneys.sort(
        (a: IFlightJourneys, b: IFlightJourneys) =>
          this.isDestinationDuration ? a.totaljourneyduration - b.totaljourneyduration : b.totaljourneyduration - a.totaljourneyduration
      )
    })
  }

  sortOriginByPrice() {
    this.isOriginPriceAsc = !this.isOriginPriceAsc;
    this.domesticFlightJourneys.forEach((domesticflightjourneys: IFlightSearchResponse) => {
      domesticflightjourneys.flightjourneys.sort(
        (a: IFlightJourneys, b: IFlightJourneys) =>
          this.isOriginPriceAsc ? a.flightfare.totalnet - b.flightfare.totalnet : b.flightfare.totalnet - a.flightfare.totalnet)
    })
  }

  sortDestinationByPrice() {
    this.isDestinationPriceAsc = !this.isDestinationPriceAsc;
    this.domesticFlightJourneys.forEach((domesticflightjourneys: IFlightSearchResponse) => {
      domesticflightjourneys.flightjourneys.sort(
        (a: IFlightJourneys, b: IFlightJourneys) =>
          this.isDestinationPriceAsc ? a.flightfare.totalnet - b.flightfare.totalnet : b.flightfare.totalnet - a.flightfare.totalnet)
    })
  }

  bookNow() {
    if(!localStorage.getItem('priceType')) {
      this.togglePrice('superSaver')
    }

    let deepLink: string;
    let selectFlightItem: any = {};
    let selectFlightRoundTrip: any = []

    if(this.selectedItem && this.selectedItemRound) {
      if(this.selectedItem.flightdeeplinkurl !== this.selectedItemRound.flightdeeplinkurl) {
        const rc1 = JSON.parse(this.utilities.getQueryParamsFromUrl(this.selectedItem.flightdeeplinkurl).rc)[0];
        const rc2 = JSON.parse(this.utilities.getQueryParamsFromUrl(this.selectedItemRound.flightdeeplinkurl).rc)[0];
        const newRC = JSON.stringify([rc1, rc2]);
        deepLink = `${environment.flightConfig.apiUrl}apiV2/flight/searchlink?s=1499061&rc=${this.utilities.encodeDeepLinkHash(newRC)}&ts=${this.utilities.getQueryParamsFromUrl(this.selectedItem.flightdeeplinkurl).ts}&cs=${this.utilities.getQueryParamsFromUrl(this.selectedItem.flightdeeplinkurl).cs}&ap=${this.utilities.getQueryParamsFromUrl(this.selectedItem.flightdeeplinkurl).ap}`
        selectFlightItem = this.selectedItem;
        selectFlightItem.flightdeeplinkurl = deepLink;
        selectFlightItem.flightfare.adultbasefare = this.selectedItem.flightfare.adultbasefare + this.selectedItemRound.flightfare.adultbasefare
        selectFlightItem.flightfare.adulttax = this.selectedItem.flightfare.adulttax + this.selectedItemRound.flightfare.adulttax
        selectFlightItem.flightfare.childbasefare = this.selectedItem.flightfare.childbasefare + this.selectedItemRound.flightfare.childbasefare
        selectFlightItem.flightfare.childtax = this.selectedItem.flightfare.childtax + this.selectedItemRound.flightfare.childtax
        selectFlightItem.flightfare.currency = this.selectedItem.flightfare.currency
        selectFlightItem.flightfare.infantbasefare = this.selectedItem.flightfare.infantbasefare + this.selectedItemRound.flightfare.infantbasefare
        selectFlightItem.flightfare.infanttax = this.selectedItem.flightfare.infanttax + this.selectedItemRound.flightfare.infanttax
        selectFlightItem.flightfare.totalnet = this.selectedItem.flightfare.totalnet + this.selectedItemRound.flightfare.totalnet
        selectFlightItem.flightlegs = [this.selectedItem.flightlegs[0], this.selectedItemRound.flightlegs[0]];
        selectFlightRoundTrip = [this.selectedItem, this.selectedItemRound];
        console.log(selectFlightRoundTrip, 'Slelected Flight other');
      } else {
        deepLink = this.selectedItem.flightdeeplinkurl;
        selectFlightItem = this.selectedItem;
        selectFlightItem.flightfare.adultbasefare = this.selectedItem.flightfare.adultbasefare + this.selectedItem.flightfare.adultbasefare
        selectFlightItem.flightfare.adulttax = this.selectedItem.flightfare.adulttax + this.selectedItem.flightfare.adulttax
        selectFlightItem.flightfare.childbasefare = this.selectedItem.flightfare.childbasefare + this.selectedItem.flightfare.childbasefare
        selectFlightItem.flightfare.childtax = this.selectedItem.flightfare.childtax + this.selectedItem.flightfare.childtax
        selectFlightItem.flightfare.currency = this.selectedItem.flightfare.currency
        selectFlightItem.flightfare.infantbasefare = this.selectedItem.flightfare.infantbasefare + this.selectedItem.flightfare.infantbasefare
        selectFlightItem.flightfare.infanttax = this.selectedItem.flightfare.infanttax + this.selectedItem.flightfare.infanttax
        selectFlightItem.flightfare.totalnet = this.selectedItem.flightfare.totalnet + this.selectedItem.flightfare.totalnet
      }
    }

    this.flight.getBookingIdFromDeepLink(deepLink).subscribe((res: IFlightDeepLinkResponse) => {
      if (res && res.booking_id) {
        const flightDetail = this.cryptoService.encrypt(JSON.stringify(selectFlightItem));
        const bookingId = this.cryptoService.encrypt(res.booking_id);
        const flightType = this.cryptoService.encrypt('round_way');
        const passengerRules = this.cryptoService.encrypt(JSON.stringify(res.passenger_rules));
        const flightSearchRequest = this.cryptoService.encrypt(JSON.stringify(this.flightRequest));
        localStorage.setItem('FlightRoundTrip__', JSON.stringify(selectFlightRoundTrip));
        localStorage.setItem('flightDetail', flightDetail);
        localStorage.setItem('bookingId', bookingId);
        localStorage.setItem('flightType', flightType);
        localStorage.setItem('flightSearchRequest', flightSearchRequest);
        localStorage.setItem('passengerRules', passengerRules);
        if(this.authService.loggedIn()) {
          this.router.navigate([`/u/flights/booking/${res.booking_id}`]);
        } else {
          this.router.navigate([`/booking/${res.booking_id}`]);
        }

      } else {
        this.snackbar.open('Something went wrong.', 'Error', {
          duration: 3000,
          panelClass: ['loginError'],
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });
      }
    })
  }

  togglePrice(priceType: string) {
    this.selectedPriceType = priceType;
    localStorage.setItem('priceType', priceType);
  }

  toggleiconsv() {
    this.ticonv=!this.ticonv;
    this.tflexv=false;
    this.teasyv=false;
  }

  toggleicons1v() {
    this.ticonv=false;
    this.tflexv=!this.tflexv;
    this.teasyv=false;
  }

  toggleicons2v() {
    this.ticonv=false;
    this.tflexv=false;
    this.teasyv=!this.teasyv;
  }

}
